"use client";

import React from "react";
import { Facebook, Heart, MessageCircle, ThumbsUp } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardFooter, CardHeader } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const reviews = [{
  id: "rev-1",
  name: 'Edward "The Ninja" Massey',
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1691064/img/avatar_edward_massey.png",
  date: "May 6 at 2:13 PM",
  text: "They did my fiancee's bridal shower. She said it was a great experience and all the ladies had a blast!",
  likes: 0,
  comments: 0
}, {
  id: "rev-2",
  name: "Team Ninja",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1691064/img/avatar_team_ninja.png",
  date: "May 6 at 2:07 PM",
  text: "Beautiful set up! A must have experience at your event !",
  likes: 0,
  comments: 0
}, {
  id: "rev-3",
  name: "Ninja Creative LLP",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1691064/img/avatar_ninja_creative.png",
  date: "May 5 at 12:50 AM",
  text: "This is the perfect addition to any event! Guests get to create their own beautiful bouquet with fresh flowers, and the ladies are so kind and welcoming. It truly makes the experience unforgettable.",
  likes: 0,
  comments: 0
}, {
  id: "rev-4",
  name: "Delilah Chacon",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1691064/img/avatar_delilah_chacon.png",
  date: "April 26",
  text: "Fresh flowers, clean layout and super easy process. 10/10 recommend. Ladies are very helpful and knowledgeable when it comes to creating your bouquet.",
  likes: 1,
  comments: 0
}, {
  id: "rev-5",
  name: "Devreen DesAutel",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1691064/img/avatar_devreen_desautel.png",
  date: "April 23",
  text: "The layout was fresh and put together well. I would recommend this business. Solid 5 stars",
  likes: 0,
  comments: 0
}, {
  id: "rev-6",
  name: "Cheyenne Brambello",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1691064/img/avatar_cheyenne_brambello.png",
  date: "April 23",
  text: "The cutest flower bar set up! Perfect for all things that call for celebration! I love the variety and colors in flowers and the ability to create all the prettiest bouquets. I definitely will be booking them for all future celebrations!",
  likes: 1,
  comments: 1
}];
export default function FacebookTestimonials() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}